<div class="container-search-box">
  <button type="button" class="search-button" (click)="open()">
    <span class="material-symbols-outlined">search</span>
  </button>
</div>

<search-box-modal></search-box-modal>
